import React from "react";
import { useToast } from "../../../context/toastContext";
import { getCarrierTrackingUrl } from "../../../utils/carrierTracking";

const CopyIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </svg>
);

const ShippingSection = ({ order }) => {
    const toast = useToast();

    if (!order.tracking_number && !order.shipped_at) return null;

    const trackingUrl = order.fulfillment_method === "carrier_shipping"
        ? getCarrierTrackingUrl(order.shipping_carrier, order.tracking_number)
        : null;

    const handleCopy = async () => {
        if (!order.tracking_number) return;
        try {
            await navigator.clipboard.writeText(order.tracking_number);
            toast.success("Tracking number copied to clipboard");
        } catch {
            toast.error("Failed to copy tracking number");
        }
    };

    const formattedDate = order.shipped_at
        ? new Date(order.shipped_at).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
          })
        : null;

    return (
        <div className="shipping-section">
            <h4 className="shipping-section__title">Shipping</h4>
            <div className="shipping-section__details">
                {order.tracking_number && (
                    <div className="shipping-section__row">
                        <span className="shipping-section__label">Tracking Number</span>
                        <button
                            className="shipping-section__tracking"
                            onClick={handleCopy}
                            title="Click to copy"
                            type="button"
                        >
                            <span className="shipping-section__tracking-text">
                                {order.tracking_number}
                            </span>
                            <CopyIcon />
                        </button>
                    </div>
                )}
                {order.shipping_carrier && (
                    <div className="shipping-section__row">
                        <span className="shipping-section__label">Carrier</span>
                        <span className="shipping-section__value">{order.shipping_carrier}</span>
                    </div>
                )}
                {formattedDate && (
                    <div className="shipping-section__row">
                        <span className="shipping-section__label">Shipped Date</span>
                        <span className="shipping-section__value">{formattedDate}</span>
                    </div>
                )}
            </div>
            {trackingUrl && (
                <a
                    className="shipping-section__track-parcel"
                    href={trackingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Track parcel (opens in new tab)
                </a>
            )}
        </div>
    );
};

export default ShippingSection;
